import { useCurrentDevice } from "../hooks";
import { faPlay, faPause, faReply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface PlayBackControlsProps {
  isPaused: boolean;
  onClickPlayPause: () => void;
  onClickBackward: () => void;
}

const PlayBackControls: React.FC<PlayBackControlsProps> = ({
  isPaused,
  onClickPlayPause,
  onClickBackward,
}) => {
  const { isComp } = useCurrentDevice();
  if (isComp) {
    return null;
  }
  return (
    <div className="flex font-bold font-xl border border-x-0 border-b-0 border-gray-300">
      <button
        onClick={onClickBackward}
        className="w-[10%] flex justify-center border border-y-0 border-l-0 border-gray-300 p-4"
      >
        <FontAwesomeIcon icon={faReply} />
      </button>
      <button
        onClick={onClickPlayPause}
        className="w-[80%] flex justify-center p-4"
      >
        <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />
      </button>
      <button
        onClick={onClickBackward}
        className="w-[10%] flex justify-center border border-y-0 border-r-0 border-gray-300 p-4"
      >
        <FontAwesomeIcon icon={faReply} />
      </button>
    </div>
  );
};

export default PlayBackControls;
